import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  FormControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from '@angular/forms';
import { ScholarshipSessionDto } from '@cradua/data';

@Component({
  selector: 'mrsoftapps-scholarship-session-view',
  templateUrl: './scholarship-session-view.component.html',
  styleUrls: ['./scholarship-session-view.component.css'],
})
export class ScholarshipSessionViewComponent implements OnInit {
  @Input() scholarshipSessions: ScholarshipSessionDto[];
  scholarshipSessionForm: FormGroup;
  control = new FormControl();
  @Output() changeEmit = new EventEmitter<ScholarshipSessionDto>();
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() printEvent = new EventEmitter<any>();

  SubscriberId = '5ca0c7a7ef1d2e5760762ebd';
  filteredDelete: Array<any> = [];
  loading = true;
  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.scholarshipSessionForm = this.fb.group({
      ScholarshipSessions: this.fb.array([]),
    });
    this.setScholarshipSession();
  }

  clickme(value) {
    console.log('click ', value);
  }

  // method to display scholarshipSessions
  setScholarshipSession() {
    const control = this.scholarshipSessionForm.controls
      .ScholarshipSessions as FormArray;
    this.scholarshipSessions.forEach((e) => {
      control.push(
        this.fb.group({
          ScholarshipSessionName: e.ScholarshipSessionName,
          id: e.id,
        })
      );
    });
  }

  // method to add ScholarshipSession
  addScholarshipSession() {
    const control = this.scholarshipSessionForm.controls
      .ScholarshipSessions as FormArray;
    control.insert(
      0,
      this.fb.group({
        ScholarshipSessionName: ['', Validators.required],
        id: null,
      })
    );
  }

  print(event: any) {
    window.print();
  }
  // method to delete scholarshipSession from arrary list
  deleteScholarshipSession(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.scholarshipSessionForm.controls
          .ScholarshipSessions as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.scholarshipSessions.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.scholarshipSessions[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  onSubmit(formValue: any) {
    formValue.type = 'scholarshipSession';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length !== 0) {
      this.filteredDelete.unshift('scholarshipSession');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }
}
